import { PageInPhoneFrame } from "@/components/ui/PageInPhoneFrame/PageInPhoneFrame";
import { env } from "@/env";
import { routes } from "@/shared/routes";

export function ReportAssetFrame() {
  return (
    <PageInPhoneFrame
      desiredWidth={400}
      src={`${env.VITE_APP_URL}${routes.assetReport}`}
    />
  );
}
